import * as React from "react";
import { Typography, Stack, Icon, Paper } from "@mui/material";
import { format as DateFormat } from "date-fns";
import PropTypes from "prop-types";

const Guardados = (props) => {
  const { listado, color, seleccionados, setSeleccionados } = props;

  return (
    listado &&
    listado.map((g) => (
      <Paper
        sx={{
          p: 1,
          backgroundColor: seleccionados.includes(g.Id)
            ? color.selected
            : color.main,
          border: "1px solid " + color.sText,
        }}
        onClick={(e) => {
          if (seleccionados.includes(g.Id))
            setSeleccionados([...seleccionados].filter((d) => d !== g.Id));
          else setSeleccionados([...seleccionados, g.Id]);
        }}
      >
        <Stack direction="row">
          <Icon
            sx={{
              ml: 0.5,
              mr: 2,
              color: color.sText,
            }}
            fontSize="large"
          >
            today
          </Icon>

          <Stack sx={{ flexGrow: 1 }}>
            <Stack direction="row">
              <Typography
                variant="caption"
                sx={{ color: color.pText, flexGrow: 1 }}
              >
                {DateFormat(new Date(g.Fecha), "dd/MM/yyyy HH:00")}
              </Typography>
              <Typography variant="caption" sx={{ color: color.sText }}>
                {g.Dias + " día" + (g.Dias > 1 ? "s" : "")}
              </Typography>
            </Stack>
            <Typography
              variant="caption"
              sx={{ lineBreak: "nowrap", color: color.pText }}
            >
              {g.Texto}
            </Typography>
          </Stack>
        </Stack>
      </Paper>
    ))
  );
};
Guardados.propTypes = {
  listado: PropTypes.array,
  color: PropTypes.object,
  seleccionados: PropTypes.array,
  setSeleccionados: PropTypes.func,
};
export default Guardados;
